import { getTestAttributes, slug } from '@chillibean/component-library';
import { useState, useEffect, useRef } from 'react';
import { getFieldTitle } from '../../../__util__/field';
import withInputLabel from '../hoc/withInputLabel';
import { clsx } from 'clsx';

export function SelectField(props) {
  const {
    disabled,
    handleChange,
    handleBlur,
    handleClick,
    fieldRequired,
    fieldName,
    fieldIdentifier = 'select',
    showError,
    errorMessage,
    required,
    options,
    value,
    hasBlankField = false,
    fieldID = '',
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    document.addEventListener('click', checkIfDropDownClicked);

    return function cleanup() {
      document.removeEventListener('click', checkIfDropDownClicked);
    };
  });

  const checkIfDropDownClicked = (event) => {
    if (!dropdownRef?.current || dropdownRef?.current.contains(event.target)) return;
    isOpen && closeDropDownList();
  };

  const toggleIsOpen = (event) => {
    setIsOpen(!isOpen);
    handleOnClick(event);
  };

  const onOptionClicked = (value) => {
    handleOnChange(value);
    setIsOpen(false);
  };

  const closeDropDownList = () => {
    setIsOpen(false);
  };

  const isArray = () => {
    return Array.isArray(options);
  };

  const handleOnChange = (event) => handleChange && handleChange(event, 'dropdown');
  const handleOnBlur = (event) => handleBlur && handleBlur(event, 'dropdown');
  const handleOnClick = (event) => handleClick && handleClick(event);

  return (
    <div className="form__field form__field--dropdown">
      <div>
        <input
          className={clsx({
            'form__control': true,
            'form__control--dropdown': true,
            'form__control--validation-error': showError,
          })}
          style={!fieldName ? { paddingTop: '15px' } : null}
          id={fieldID}
          onClick={(event) => toggleIsOpen(event)}
          onBlur={(event) => handleOnBlur(event)}
          readOnly
          required={required}
          disabled={disabled}
          placeholder={' '}
          value={isArray() ? value : options[value]}
          {...getTestAttributes(`${slug(fieldIdentifier)}-form-field`)}
          ref={dropdownRef}
        />
        <label htmlFor={fieldID}>{getFieldTitle(fieldRequired, fieldName)}</label>
        <div className={clsx({
          'dropdown__list-wrapper': true,
          'show': isOpen,
          'hide': !isOpen,
        })}>
          <ul>
            {hasBlankField && (
              <li
                className="dropdown__list-item"
                key="blank"
                onClick={() => onOptionClicked('')}
                id="list-item-blank"
                {...getTestAttributes('list-item-blank')}
              >
                <span className="dropdown__list-item--visibility-none">Clear</span>
              </li>
            )}
            {Object.entries(options).map(([key, value], index) => (
              <li
                className="dropdown__list-item"
                key={key}
                onClick={() => onOptionClicked(isArray() ? value : key)}
                id={`${fieldID}_list-item_${index + 1}`}
                {...getTestAttributes(`${fieldID}-list-item-${slug(value)}`)}
              >
                {value}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {showError && (
        <div className="form__validation-error" data-test-id={`${slug(fieldIdentifier)}-form-field-error-message`}>
          {errorMessage}
        </div>
      )}{' '}
    </div>
  );
}

export default withInputLabel(SelectField);
